import { render, staticRenderFns } from "./TdDeviceSort.vue?vue&type=template&id=2c53bee4&"
import script from "./TdDeviceSort.vue?vue&type=script&lang=js&"
export * from "./TdDeviceSort.vue?vue&type=script&lang=js&"
import style0 from "./TdDeviceSort.vue?vue&type=style&index=0&id=2c53bee4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports